import React from 'react'
import { MdArrowBackIosNew } from "react-icons/md";
import './Calendar.css';
import 'react-photo-view/dist/react-photo-view.css';
import { BsCloudDownload } from "react-icons/bs";
import janCal from "../Images/calendar/Jan2025.webp";
import febCal from "../Images/calendar/Feb2025.webp";
import marCal from "../Images/calendar/Mar2025.webp";
import aprCal from "../Images/calendar/Apr2025.webp";
import mayCal from "../Images/calendar/May2025.webp";
import juneCal from "../Images/calendar/June2025.webp";
import julyCal from "../Images/calendar/July2025.webp";
import augCal from "../Images/calendar/Aug2025.webp";
import sepCal from "../Images/calendar/Sep2025.webp";
import octCal from "../Images/calendar/Oct2025.webp";
import novCal from "../Images/calendar/Nov2025.webp";
import decCal from "../Images/calendar/Dec2025.webp";
import { PhotoProvider, PhotoView } from 'react-photo-view';

function RamzanCalendar() {
  const calendarImages = [
  { src: janCal, title: 'January 2025' },
  { src: febCal, title: 'February 2025' },
  { src: marCal, title: 'March 2025' },
  { src: aprCal, title: 'April 2025' },
  { src: mayCal, title: 'May 2025' },
  { src: juneCal, title: 'June 2025' },

  { src: julyCal, title: 'July 2025' },
  { src: augCal, title: 'Aug 2025' },
  { src: sepCal, title: 'Sep 2025' },
  { src: octCal, title: 'Oct 2025' },
  { src: novCal, title: 'Nov 2025' },
  { src: decCal, title: 'NocDec 2025' },

  // Add the rest here like
  // { src: marCal, title: 'March 2025' },
];

  return (
    <div className='contain'>
        <div className="page-header">
          <span className="backBtn" onClick={()=> window.history.back()}>
            <MdArrowBackIosNew />
          </span>
          <div className="page-header__content">
            <h1 className="pagetitle">Calendar 2026</h1>
          </div>
       </div>

           <div className="contentSection">
            <div className='calendar-section'>
              <PhotoProvider
                speed={() => 800}
                easing={(type) => (type === 2 ? 'cubic-bezier(0.36, 0, 0.66, -0.56)' : 'cubic-bezier(0.34, 1.56, 0.64, 1)')}  >
                {calendarImages.map((item, index) => (
                  <div key={index} style={{ marginBottom: '20px' }}>
                    <PhotoView src={item.src}>
                      <img
                        title={item.title}
                        src={item.src}
                        alt={item.title}
                       style={{ width: '100%', cursor: 'pointer' }}
                      />
                    </PhotoView>
                    <span className="download-text">
                      <a href={item.src} download>
                        Download <BsCloudDownload />
                      </a>
                    </span>
                  </div>
                ))}
              </PhotoProvider>
        </div>
           </div>
    </div>
  )
}

export default RamzanCalendar